<div class="form-item" [class.tableFilterClass] = "tableFilterClass" [class.mb-0] = "removeMarginBottom" [class.disableHover] = "this.selectedElement != null || hasError">
  <div class="input-div" [class.urlBorder]="urlInput" [class.isDisabled] = "disabled" [class.hasFocus] = "this.selectedElement != null" [class.hasError] = "hasError || invalidSn?.length">
    <label for="" *ngIf="fieldHasValue?.length > 0 && ariaLabel != true">
      {{options.label | translate}}<span *ngIf="options.isRequired">*</span></label>
    <input [class.urlInput]="(urlInput)" [class.setWidth]="hasSearch" [class.unSetWidth] = "hasSearch && fieldHasValue?.length > 0 "
     [type]="isText?'text':'number'"
     (keydown)="onKeyDown($event)"
      placeholder="{{getPlaceholder(options)}}"
      (focus)="onFocus($event)"
      (blur)="onFocus(null)"
      [class.empty-box]="fieldHasValue?.length == 0"
      [readonly] = "readonly"
      [formControl]="control"
      (keyup)="onChange($event)" 
      (keypress)="preventNonNumericalInput($event)"
      [tabindex] = 'disabled ? -1 : tabindex'
      [attr.aria-label]="ariaLabel == true ? getLabel(options) : 'search query'"
      >
      <div  *ngIf="hasSearch">
        <img class="close-icon" title="Clear" (click) = "clearInput()" (keydown.enter)="clearInput()" (keyup.enter)="clearInput()" *ngIf="fieldHasValue?.length > 0" src="./assets/icons/icon_close.svg" alt="clear" role="button" tabindex="0">
        <img class="search-icon" (click) = "$event.stopPropagation()" src="./assets/icons/icon_search.svg" alt="search">
      </div>
  </div>

  <div class="text-box-error" *ngIf="hasError || invalidSn?.length">
     <div><img src="./assets/icons/required-minus.svg" alt="required-minus-icon"></div>
     <div class="error_text ">{{ errorMessage | translate}}</div>
     <div class="error_text " *ngIf="fieldHasValue?.length > 0">{{invalidSn}}</div>
  </div>
</div>
